import { jsx as _jsx } from "preact/jsx-runtime";
import { ScheduleXCalendar } from '@/components/calendar/ScheduleXCalendar';
export function CampaignCalendarTab({ campaign, clientCompanyId }) {
    return (_jsx("div", { className: "-m-6", children: _jsx(ScheduleXCalendar, { clientCompanyId: clientCompanyId, workspaceId: campaign.WorkspaceId, campaignId: campaign.Id }) }));
}
